/* eslint-disable no-shadow */
/* eslint-disable no-use-before-define */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { findIndex, find } from 'lodash';
import { withRouter } from 'react-router-dom';
import { Scrollbars } from 'react-custom-scrollbars';
import crypto from 'crypto-js';

import moment from 'moment';
import { getPlayerName } from '../../../utils';
import EventRegForm from '../../EventRegForm';
import { optionalEmail } from '../../../utils/validation';
import { eventDivisionIsPlatformPaymentOrFree, EventTypes, areAllPlayableDivisionsAnnualPowerOnly } from '../../../utils/events';
import { nonPoweredPlayerDefaultDivisionFee, SubscriptionIntervalTypes } from '../../../utils/constants';
import { getUsapMessageFromError } from '../../../utils/usap';
import { getApiAxiosInstance } from '../../../utils/network';
import UpgradeToPowerPopUp from '../../Upgrade/UpgradeToPowerPopUp';
import useStartPowerCheckout from '../../hooks/useStartPowerCheckout';
import { addTeammateToDivison, selfWithdrawFromEvent, getRestrictedDivisions } from '../../../actions/event-actions';
import { fetchUpgradePopup } from '../../../actions/upgrade-to-power-actions';
import { showErrorPopup } from '../../../actions/notification-actions';
import { gtag } from '../../Analytics/gtag';
import * as checkoutEventRegistrationApi from '../../../api/checkoutEventRegistrationApi';
import {
    saveAnswers,
    validatePassword,
} from '../../../api/tmsEventsApi';

import { getPaymentMethods } from '../../../actions/member-payment-actions';
import Splash from '../../Splash';
import paymentsConstants from '../../../../constants/payments';
import { eventTypesById } from '../../../utils/eventConstants';
import { trackEvent } from '../../Analytics/TrackedClick';

const _ = { findIndex, find };

const SideBar = (props) => {
    const { sidebarOpen, sidebarState } = props;
    const { auth, events } = useSelector((state) => state);
    const dispatch = useDispatch();
    const { startPowerCheckout } = useStartPowerCheckout();

    const { currentEvent } = events;
    const { data: event = {} } = currentEvent;

    const claimedPlayer = auth?.user?.claimedPlayer;
    const areAllDivisionsAnnualPowerOnly = areAllPlayableDivisionsAnnualPowerOnly(event);
    const { paymentTitles } = paymentsConstants;

    // eslint-disable-next-line todo-comments/todo-comments
    // TODO (davecohen): Remove this and related code with HUB-526
    const saveCardEnabled = false;

    const [requestToJoinClub, setRequestToJoinClub] = useState(true);
    const [eventFee, setEventFee] = useState(0);
    const [eventFeeOffPlatform, setEventFeeOffPlatform] = useState(0);
    const [financeAndAdminFee, setFinanceAndAdminFee] = useState(0);
    const [regTotal, setRegTotal] = useState(0);
    const [regTotalOffPlatform, setRegTotalOffPlatform] = useState(0);
    const [showUpgradeToPowerPopUp, setShowUpgradeToPowerPopUp] = useState(false);
    const [isProTennisPowerUpgrade, setIsProTennisPowerUpgrade] = useState(false);
    const [regStep, setRegStep] = useState({});
    const [selectedDivisionIds, setSelectedDivisionIds] = useState([]);
    const [registerSubmitting, setRegisterSubmitting] = useState(false);
    const [paymentTitle, setPaymentTitleState] = useState(null);
    const [savedPaymentMethods, setSavedPaymentMethods] = useState([]);
    const [showSplash, setShowSplash] = useState(false);

    const getPlayerPaymentMethods = async () => {
        if (saveCardEnabled) {
            setShowSplash(true);
            const playerPaymentMethods = await dispatch(getPaymentMethods(false)); // NOSONAR — Redux thunk returns a promise
            setSavedPaymentMethods(playerPaymentMethods);
            setShowSplash(false);
        }
    };
    useEffect(() => {
        let registrationStepToSet = null;
        if (showUpgradeStep(event)) {
            registrationStepToSet = {
                id: 'upgrade',
                title: 'Upgrade to Power',
            };
        } else if (event?.passwordEnabled) {
            registrationStepToSet = {
                id: 'password',
                title: 'Enter Password',
            };
        } else {
            registrationStepToSet = {
                id: 'divisions',
                title: event.registered ? 'Update Divisions' : 'Select Divisions',
            };
        }

        setRegStep(registrationStepToSet);
        getPlayerPaymentMethods();
    }, []);

    useEffect(() => {
        if (sidebarState && sidebarState.id !== regStep.id) {
            setRegStep(sidebarState);
        }
    }, [sidebarState]);

    const getUnregisteredPlayers = () => {
        const unregisteredPlayers = [];
        if (!event.registered && auth.user?.claimedPlayer) {
            unregisteredPlayers.push({
                id: auth.user.claimedPlayer.playerId.toString(),
                displayName: `${auth.user.claimedPlayer.firstName} ${auth.user.claimedPlayer.lastName}`,
                key: `withid-${auth.user.claimedPlayer.playerId.toString()}`,
            });
        }
        const selectedDivisions = event.eventDivisions.filter(d => selectedDivisionIds.includes(d.id));

        selectedDivisions.forEach((div) => {
            if (div.player2) {
                const player = {};
                if (div.player2.id) {
                    player.id = div.player2.id;
                    player.displayName = div.player2.displayName;
                    player.key = `withid-${div.player2.id}`;
                    if (div.player2.profileId <= 0) {
                        player.email = div.player2.email;
                    }

                    const index = _.findIndex(unregisteredPlayers, { id: div.player2.id });
                    let registerPlayerIndex = -1;
                    if (event.registeredPlayers) {
                        registerPlayerIndex = _.findIndex(event.registeredPlayers, { id: parseInt(div.player2.id) });
                    }
                    if (index === -1 && registerPlayerIndex === -1) {
                        unregisteredPlayers.push(player);
                    }
                } else {
                    player.displayName = div.player2.name;
                    player.email = div.player2.email;
                    player.key = `withoutid-${crypto.MD5(div.player2.email).toString()}`;

                    const index = _.findIndex(unregisteredPlayers, { email: div.player2.email });
                    if (index === -1) {
                        unregisteredPlayers.push(player);
                    }
                }
            }
        });
        return unregisteredPlayers;
    };

    const setCheckoutSubmittingFlag = (submitting) => {
        setRegisterSubmitting(!!submitting);
    };

    const handlePowerSuccess = () => {
        regToStep(event.passwordEnabled ? 'password' : 'divisions');
        closePowerPopUp();
    };

    const handleSelfWithdraw = (withdrawPayload) => {
        setRegisterSubmitting(true);
        dispatch(selfWithdrawFromEvent(withdrawPayload));
    };

    const regToStep = (step, divisionId) => {
        switch (step) {
            case 'upgrade':
                setRegStep({
                    id: 'upgrade',
                    title: 'Upgrade to Power',
                });
                break;
            case 'password': {
                setRegStep({
                    id: 'password',
                    title: 'Enter Password',
                });
                break;
            }
            case 'divisions':
                setRegStep({
                    id: 'divisions',
                    title: event.registered ? 'Update Divisons' : 'Select Divisons',
                });
                setPaymentTitle(paymentTitles.none);
                break;

            case 'divisions-add':
                setRegStep({
                    id: 'divisions-add',
                    title: event.registered ? 'Update Divisons' : 'Select Divisons',
                });
                break;

            case 'divisions-cancel':
                setRegStep({
                    id: 'divisions-cancel',
                    title: 'Select Registrations',
                });
                break;

            case 'teammate':
                setRegStep({
                    id: 'teammate',
                    title: `Add Partner`,
                    divisionId,
                    invite: 'existing',
                    errors: {
                        existingEmail: false,
                        inviteEmail: false,
                    },
                });
                break;

            case 'questions':
                setRegStep({
                    id: 'questions',
                    title: 'Event Questions',
                });
                break;

            case 'confirm':
                setRegStep({
                    id: 'confirm',
                    title: 'Confirm Selection',
                });
                break;
            case 'payment':
                setRegStep({
                    id: 'payment',
                    title: 'Enter Payment',
                });
                break;
            default:
                break;
        }
    };

    const toggleDivisions = (divisionIds) => {
        const selectedDivisionIdsUpdate = [...selectedDivisionIds];
        divisionIds.forEach(divisionId => {
            const idx = selectedDivisionIdsUpdate.indexOf(divisionId);
            if (idx > -1) {
                selectedDivisionIdsUpdate.splice(idx, 1);
            } else {
                selectedDivisionIdsUpdate.push(divisionId);
            }
        });
        setSelectedDivisionIds(selectedDivisionIdsUpdate);
    };

    const regToggleDivision = (i) => {
        const divisionIndexes = [i];
        regToggleDivisions(divisionIndexes);
    };

    const regToggleDivisions = (i) => {
        const { verificationFee, workflowVersion, paymentProviderType } = event;
        let eventFee = 0;
        let eventFeeOffPlatform = 0;
        const financeAndAdminFee = 0;
        let total = 0;
        const divisionIdsToToggle = [];

        if (i.length) {
            i.forEach(index => {
                event.eventDivisions.forEach((div, j) => {
                    if ((index === j && !selectedDivisionIds.includes(div.id)) || (index !== j && selectedDivisionIds.includes(div.id))) {
                        const eventVerificationFeeParsed = parseFloat(verificationFee) || 0;
						const clubVerificationFee = eventVerificationFeeParsed >= 0 ? eventVerificationFeeParsed : nonPoweredPlayerDefaultDivisionFee;
                        const eventDivisionIsPlatformPaymentOrFreeResult = eventDivisionIsPlatformPaymentOrFree(div);
                        const addToEventFee = (eventDivisionIsPlatformPaymentOrFreeResult && !event.allowOffPlatformPayments);

                        if (!auth.user.isPowered && event.utrType.value === 'sanctioned' && workflowVersion > 1 && clubVerificationFee > 0 && addToEventFee) {
                            eventFee += (div.entryFee + clubVerificationFee);
                        } else if (addToEventFee) {
                            eventFee += div.entryFee;
                        } else {
                            eventFeeOffPlatform += div.entryFee;
                        }
                    }

                    if (index === j) {
                        divisionIdsToToggle.push(div.id);
                    }
                });
            });

            toggleDivisions(divisionIdsToToggle);
        }

        if (eventFee > 0) {
            if (paymentProviderType.value === 'stripe') {
                total = eventFee;
            }
        }
        setEventFee(eventFee);
        setEventFeeOffPlatform(eventFeeOffPlatform);
        setFinanceAndAdminFee(financeAndAdminFee);
        setRegTotal(total);
        setRegTotalOffPlatform(eventFeeOffPlatform);
    };

    const regIsTabInvalid = (step) => {
        if (event && step === 'divisions-add') {
            let selectedDivs = 0;
            const missingPlayer = event.eventDivisions.some((div) => {
                if (selectedDivisionIds.includes(div.id)) {
                    selectedDivs += 1;
                }

                return selectedDivisionIds.includes(div.id) && div.divisionFormatType?.value === 'doubles' && !div.player2;
            });
            return selectedDivs === 0 || missingPlayer;
        }
        return false;
    };

    const regSelectTeammate = (selectedPlayer) => {
        if (selectedPlayer.id) {
            setRegStep({ ...regStep, selectedPlayer });
        } else if (selectedPlayer.query) {
            setRegStep({
                ...regStep,
                invite: 'invite',
                selectedPlayer: null,
                inviteName: selectedPlayer.query,
            });
        }
    };

    const regAddTeammate = (e) => {
        console.log('regAddTeammate');
        setRegStep({ ...regStep, invite: e.target.value });
    };

    const regAddTeammateToDivison = () => {
        const player2 = regStep.invite === 'existing' ? regStep.selectedPlayer : {
            name: regStep.inviteName,
            email: regStep.inviteEmail,
        };
        dispatch(addTeammateToDivison({ divisionId: regStep.divisionId, player2 }));
        setRegStep({
            id: 'divisions-add',
            title: event.registered ? 'Update Divisons' : 'Select Divisons',
        });
    };

    const validateEmails = () => {
        const errors = {};

        if (regStep.invite === 'existing') {
            errors.existingEmail = optionalEmail(regStep.selectedPlayer.email);
        } else {
            errors.inviteEmail = optionalEmail(regStep.inviteEmail);
        }

        if (!(errors.existingEmail || errors.inviteEmail)) {
            regAddTeammateToDivison();
        } else {
            setRegStep({
                ...regStep,
                errors,
            });
        }
    };

    const regAddUnclaimedEmail = (e) => {
        const selectedPlayer = { ...regStep.selectedPlayer, email: e.target.value };
        setRegStep({ ...regStep, selectedPlayer });
    };

    const regHandleInviteChange = (e) => {
        setRegStep({
            ...regStep,
            [e.target.name]: e.target.value,
        });
    };

    const regHandleSubmitQuestions = async ({ values }) => {
        setRegisterSubmitting(true);

        const list = {};
        Object.entries(values).forEach((entry) => {
            const array = entry[0].split('-');
            if (!list[`${array[1]}`]) {
                list[`${array[1]}`] = [];
            }
            list[`${array[1]}`].push({
                questionId: array[2],
                answer: entry[1],
            });
        });

        const selectedDivisions = event.eventDivisions.filter(d => selectedDivisionIds.includes(d.id));

        selectedDivisions.forEach((div) => {
            if (div.player2) {
                if (div.player2.id) {
                    if (list[`${div.player2.id}`]) {
                        div.player2.partnerAnswers = [{
                            partnerId: div.player2.id,
                            answers: list[`${div.player2.id}`],
                            email: div.player2.email ? div.player2.email : null,
                        }];
                    }
                } else if (list[`${crypto.MD5(div.player2.email).toString()}`]) {
                    div.player2.partnerAnswers = [{
                        email: div.player2.email,
                        answers: list[`${crypto.MD5(div.player2.email).toString()}`],
                    }];
                }
            }
        });

        const userAnswers = list[`${auth.user.claimedPlayer.playerId}`];
        if (userAnswers) {
            try {
                await saveAnswers(getApiAxiosInstance(), event.id, userAnswers);
                setRegisterSubmitting(false);
                regToStep('confirm');
            } catch (e) {
                dispatch(showErrorPopup({
                    message: 'Error saving questions',
                    error: e,
                }));
                setRegisterSubmitting(false);
            }
        } else {
            setRegisterSubmitting(false);
            regToStep('confirm');
        }
    };

    const regHandleSubmitPassword = () => {
        regToStep('divisions');
    };

    const regHandleConfirm = () => {
        if (regTotal > 0) {
            regToStep('payment');
        } else {
            setRegisterSubmitting(true);
            if (event?.paymentProviderType?.id === 2) {
                stripeSubmitRegWithoutPayment();
            }
        }
        gtag('event', {
            category: 'Checkout Started',
            context: `eventId: ${event.id}`,
        });
        // adding track calls to check impact of save card feature - mapped to GA4
        if (window?.analytics) {
            window.analytics.track('Checkout Started', {
                userId: auth.user.id,
                eventId: event.id,
            });
        }
    };

    const regHandleValidatePassword = async (values) => {
        try {
            await validatePassword(getApiAxiosInstance(), event.id, values);
            return true;
        } catch (e) {
            console.log('regHandleValidatePassword - error', e);
            return false;
        }
    };

    const regFinishPayment = () => {
        props.toRegConfirmation();
    };

    const regRequestToJoinClub = () => {
        setRequestToJoinClub(!requestToJoinClub);
    };

    // STRIPE LOGIC

    const stripePopulatePaymentRequestBody = () => {
        const selectedDivisions = event.eventDivisions.filter(d => selectedDivisionIds.includes(d.id));
        const postData = { requestToJoinClub };
        postData.divisions = selectedDivisions.map((div) => {
            const division = {
                divisionId: div.id,
            };
            if (div.player2) {
                if (div.player2.id) {
                    if (div.player2.profileId > 0) {
                        division.partnerIds = [div.player2.id];
                    } else {
                        division.playerInvites = [
                            {
                                playerId: div.player2.id,
                                email: div.player2.email,
                            },
                        ];
                    }
                } else {
                    division.playerInvites = [
                        {
                            name: div.player2.name,
                            email: div.player2.email,
                        },
                    ];
                }
                if (div.player2.partnerAnswers) {
                    division.partnerAnswers = div.player2.partnerAnswers;
                }
            }
            return division;
        });
        return postData;
    };

    const wrapUp = (checkoutId) => {
        postRegistration(checkoutId);
        setRegisterSubmitting(false);
        props.toRegConfirmation();
    };

    const stripeSubmitRegWithoutPayment = async () => {
        const postData = stripePopulatePaymentRequestBody();

        try {
            // non-payment version can stay on legacy registration interface
            // however, we will want to move the route, and provide a separate endpoint
            const res = await checkoutEventRegistrationApi.legacyMemberRegistrationCheckout(getApiAxiosInstance(), event.id, postData);
            wrapUp(res);
        } catch (error) {
            setRegisterSubmitting(false);
            console.log('Error registering for event', error);
            const retMessage = (error?.response?.data?.message?.indexOf('suspended') > -1) ? error.response.data.message : 'Error completing registration';
            const description = error?.response?.data?.DisplayMessage || error?.response?.data?.message;
            const usapValidationMessage = getUsapMessageFromError(error);

            trackEvent(`stripeSubmitRegWithoutPayment`, {
                page: 'Sidebar',
                errorMessage: retMessage,
                action: `Error-${usapValidationMessage}`,
                memberId: auth?.user?.id,
                eventId: event?.id,
                client: 'Web',
                timestamp: moment.utc(),
            });

            dispatch(showErrorPopup({
                message: retMessage,
                error: description || usapValidationMessage || 'Service is unreachable',
            }));
        }
    };

    // STRIPE LOGIC END

    const openUpgradeToPowerPopUp = () => {
        if (areAllDivisionsAnnualPowerOnly) {
            // Annual-power-only events: sub-step transition handled inside EventRegForm
            return;
        }

        let isProTennisPowerUpgrade = false;

        if (event?.eventTours.length > 0 && event.eventDivisions.length > 0) {
            const proTennisTour = _.find(event.eventTours, { name: 'UTR Pro Tennis Tour' });
            const isAnyDivisionAnnualPowerOnly = _.findIndex(event.eventDivisions, { annualPoweredOnly: true }) !== -1;
            if (proTennisTour && isAnyDivisionAnnualPowerOnly) {
                isProTennisPowerUpgrade = true;
                dispatch(fetchUpgradePopup('pts'));
            }
        }
        setShowUpgradeToPowerPopUp(true);
        setIsProTennisPowerUpgrade(isProTennisPowerUpgrade);
    };

    const handleUpgradeToPowerClick = () => {
        startPowerCheckout({ onContinue: openUpgradeToPowerPopUp });
    };

    const showUpgradeStep = (event) => {
        const userIsPowered = auth.user?.isPowered;
        const userHasAnnualPower = auth.user?.isPowered && auth.user?.subscriptionTierType === SubscriptionIntervalTypes.YEAR;
        const areAllDivisionsAnnualPowerOnly = areAllPlayableDivisionsAnnualPowerOnly(event);
        const eventVerificationFeeParsed = parseFloat(event.verificationFee) || 0;
        const clubVerificationFee = eventVerificationFeeParsed >= 0 ? eventVerificationFeeParsed : nonPoweredPlayerDefaultDivisionFee;
        const showUpgrade = (
            (
                !userIsPowered &&
                event.utrType.value === 'sanctioned' &&
                event.workflowVersion > 1 &&
                clubVerificationFee > 0
            ) ||
            (
                !userHasAnnualPower &&
                areAllDivisionsAnnualPowerOnly
            )
        );
        return showUpgrade;
    };

    const handleOverlayClick = () => {
        props.handleOverlayClick();
        let registrationStep = null;
        if (showUpgradeStep(event)) {
            registrationStep = {
                id: 'upgrade',
                title: 'Upgrade to Power',
            };
        } else if (event.passwordEnabled) {
            registrationStep = {
                id: 'password',
                title: 'Enter Password',
            };
        } else {
            registrationStep = {
                id: 'divisions',
                title: event.registered ? 'Update Divisions' : 'Select Divisions',
            };
        }

        setRegStep(registrationStep);
    };

    const handleDeclineUpgradeToPowerClick = () => {
        regToStep(event.passwordEnabled ? 'password' : 'divisions');
        props.handleDeclineUpgradeToPowerClick();
    };

    const closePowerPopUp = () => {
        setShowUpgradeToPowerPopUp(false);
    };

    const postRegistration = (checkoutId) => {
        const { name, eventType } = event;
        let isPaidHit = false;
        let isFlexLeagueEvent = false;
        let category;
        let path = regTotal > 0 ? '/event/registered-paid' : '/event/registered-free';

        switch (eventType.id) {
            case EventTypes.FLEX_LEAGUE:
                category = 'flex league';
                path = `${path}/flex-league`;
                isFlexLeagueEvent = true;
                break;
            case EventTypes.TEAM_LEAGUE:
                category = 'team tennis';
                path = `${path}/team-tennis`;
                break;
            case EventTypes.TEAM_MATCH:
                category = 'adult league';
                path = `${path}/adult-league`;
                break;
            case EventTypes.PAID_HIT:
                category = 'paid hit';
                path = `${path}/paidhit`;
                isPaidHit = true;
                break;
            default:
                category = regTotal > 0 ? 'paid event' : 'free event';
                break;
        }

        const properties = {
            path,
            url: path,
            title: name,
        };
        gtag('view', {
            category,
            context: `event registration - ${properties}`,
        });
        gtag('event', {
            category: 'Order Completed',
            context: `eventId: ${event.id}`,
        });
        if (window?.analytics) {
            window.analytics.page(category, 'event registration', properties);
            // adding track calls to check impact of save card feature for Order Completed - mapped to GA4
            window.analytics.track('Order Completed', {
                userId: auth.user.id,
                eventId: event.id,
            });
        }
        if (regTotal > 0) {
            let context = `Event: ${eventTypesById[eventType.id]}`;
            if (event?.eventTours?.length) {
                context += ` - Tour: ${event?.eventTours[0].name}`;
            }
            gtag('purchase', {
                category: 'Event Registration',
                context,
                value: regTotal,
                transaction_id: checkoutId,
            });
        }
        if (isFlexLeagueEvent && regTotal > 0) {
            // commenting out for now in case we will return back to the facebook pixel for purchase tracking
            // if (window && window.fbq) {
            //     window.fbq('track', 'Purchase', { value: regTotal, currency: 'USD', content_name: path });
            // }
            if (window?.pixie) {
                window.pixie('event', 'Flexleagues');
            }
        }
        if (isPaidHit && regTotal > 0) {
            // commenting out for now in case we will return back to the facebook pixel for purchase tracking
            // if (window && window.fbq) {
            //     window.fbq('track', 'Purchase', { value: regTotal, currency: 'USD', content_name: path });
            // }
            if (window?.pixie) {
                window.pixie('event', 'Paidhits');
            }
        }
    };

    const toggleSplashBallLoader = () => {
        setShowSplash(showSplash => (!showSplash));
    };

    const setPaymentTitle = (title) => {
        setPaymentTitleState(title);
    };

    const showPrev = !(regStep.id === 'divisions' || regStep.id === 'password') && !areAllDivisionsAnnualPowerOnly;

    return (
        <>
            <div
                id="sidebar"
                className={`${regStep.id} ${sidebarOpen ? 'open' : 'closed'}`}
            >
                <nav className="navbar navbar-light purple-grad">
                    <div className="container" style={{ position: 'relative' }}>
                        <div className="col d-flex justify-content-center align-items-center">
                            {showPrev && (
                                <div
                                    className="back-area"
                                    onClick={() => {
                                        regToStep('divisions');
                                    }}
                                >
                                    <i className="utr utr-prev" />
                                </div>
                            )}
                            <div>
                                <div className="text-highlight2 text-dark text-center">
                                    {paymentTitle || regStep.title}
                                </div>
                                <div className="text-center text-small">
                                    {claimedPlayer ? getPlayerName(claimedPlayer.firstName, claimedPlayer.lastName) : ''}
                                </div>
                            </div>
                            <div className="close-area" onClick={handleOverlayClick}>
                                <i className="utr utr-close" />
                            </div>
                        </div>

                    </div>
                </nav>
                <Scrollbars
                    style={{ height: 'calc(100vh - 89px)' }}
                    universal
                >
                    <Splash showSidebarLoader={showSplash} />
                    <EventRegForm
                        step={regStep}
                        event={event}
                        eventFee={eventFee}
                        eventFeeOffPlatform={eventFeeOffPlatform}
                        financeAndAdminFee={financeAndAdminFee}
                        total={regTotal}
                        totalOffPlatform={regTotalOffPlatform}
                        toStep={regToStep}
                        toggleDivision={regToggleDivision}
                        toggleDivisions={regToggleDivisions}
                        isTabInvalid={regIsTabInvalid}
                        selectTeammate={regSelectTeammate}
                        addTeammate={regAddTeammate}
                        addTeammateToDivision={validateEmails}
                        addUnclaimedEmail={regAddUnclaimedEmail}
                        handleInviteChange={regHandleInviteChange}
                        handleSubmitQuestions={regHandleSubmitQuestions}
                        handleConfirm={regHandleConfirm}
                        handleSubmitPassword={regHandleSubmitPassword}
                        handleValidatePassword={regHandleValidatePassword}
                        finishPayment={regFinishPayment}
                        submitting={registerSubmitting}
                        user={auth.user}
                        unRegisteredPlayers={getUnregisteredPlayers()}
                        requestToJoinClub={requestToJoinClub}
                        handleRequestToJoinClubChange={regRequestToJoinClub}
                        handleUpgradeToPowerClick={handleUpgradeToPowerClick}
                        handleDeclineUpgradeToPowerClick={handleDeclineUpgradeToPowerClick}
                        onUpgradeComplete={() => regToStep(event.passwordEnabled ? 'password' : 'divisions')}
                        setCheckoutSubmittingFlag={setCheckoutSubmittingFlag}
                        stripePopulatePaymentRequestBody={stripePopulatePaymentRequestBody}
                        stripePaymentSuccessWrapUp={wrapUp}
                        selectedDivisionIds={selectedDivisionIds}
                        submitSelfWithdraw={handleSelfWithdraw}
                        sidebarOpen={sidebarOpen}
                        getRestrictedDivisions={(args) => dispatch(getRestrictedDivisions(args))}
                        savedPaymentMethods={savedPaymentMethods}
                        setPaymentTitle={setPaymentTitle}
                        toggleSplashBallLoader={toggleSplashBallLoader}
                        location={props.location}
                    />
                </Scrollbars>
            </div>
            <div
                id="sidebar-overlay"
                className={sidebarOpen ? 'open' : 'closed'}
                onClick={handleOverlayClick}
            />
            {showUpgradeToPowerPopUp && (
                <UpgradeToPowerPopUp
                    onCloseClick={closePowerPopUp}
                    onSuccess={handlePowerSuccess}
                    isProTennisPowerUpgrade={isProTennisPowerUpgrade}
                />
            )}
        </>
    );
};
export default withRouter(SideBar);
